import React, { useContext, useEffect, useState, useMemo } from "react";
// import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Badge from "@mui/material/Badge";
import { useNavigate, useLocation } from "react-router-dom";
import UserContext from "../contexts/UserContext";
import DjContext from "../contexts/DJContext";
import ProfileModal from "../components/ProfileModal";
import config from "../config";

const routes = [
  ["/events", "Events"],
  ["/playlists", "Events"],
  ["/requests", "Events"],
  ["/promotions", "Promotions"],
  ["/payments", "Payments"],
  ["/notifications", "Notifications"],
  ["/library", "Library"],
  ["/venues", "Venues"],
  ["/users", "Users"],
  ["/djs", "DJs"],
  ["/admins", "Admins"],
  ["/login", "Log In"],
  ["/register", "Sign Up"],
];

const ResponsiveAppBar = () => {
  const [state, setState] = useState({
    pages: [],
    settings: [],
  });

  const userContext = useContext(UserContext);
  const djContext = useContext(DjContext);
  const navigate = useNavigate();
  const location = useLocation();

  const isInitialDJSignup = useMemo(() => {
    return userContext.user?.isDJ && userContext.user?.name === "DJ";
  }, [userContext.user]);

  const setActivePage = (location) => {
    const activeRoute = routes.find(([route]) =>
      location.pathname.startsWith(route)
    );
    const activePage = activeRoute && activeRoute[1];
    setState((s) => ({
      ...s,
      activePage,
    }));
  };

  useEffect(() => {
    setActivePage(location);
  }, [location]);

  const handleOpenProfileModal = () => {
    setState((s) => ({
      ...s,
      open: true,
    }));
  };

  const handleClose = () => {
    setState((s) => ({
      ...s,
      open: false,
    }));
  };

  // useEffect(() => {
  //   (async () => {
  //     if (userContext.fetchedUser) {
  //       if (userContext.user.stripeConnectedAccountId) {
  //         const account = await getStripeAccount();
  //         console.log("are we fetching?");
  //         // console.log(account);
  //         if (
  //           account.details_submitted &&
  //           account.charges_enabled &&
  //           account.capabilities.transfers === "active" &&
  //           account.payouts_enabled
  //           // account.requirements.currently_due.length === 0 &&
  //           // account.requirements.eventually_due.length === 0 &&
  //           // account.requirements.past_due.length === 0 &&
  //           // account.future_requirements.currently_due.length === 0 &&
  //           // account.future_requirements.eventually_due.length === 0 &&
  //           // account.future_requirements.past_due.length === 0
  //         ) {
  //           const loginLink = await getStripeAccountLoginLink();

  //           userContext.setUser({ ...userContext.user, loginLink });
  //         }
  //       }
  //     }
  //   })();
  // }, [userContext?.fetchedUser, userContext?.user?.stripeConnectedAccountId]);

  useEffect(() => {
    const pages = [];
    const settings = [];
    if (userContext.user) {
      if (isInitialDJSignup || location.pathname.startsWith("/profile"))
        handleOpenProfileModal();
      pages.push(["Events", () => navigate("/events")]);
      pages.push(["Venues", () => navigate("/venues")]);
      if (["admin"].includes(userContext.user.role))
        pages.push(["DJs", () => navigate("/djs")]);
      if (
        ["admin"].includes(userContext.user.role) &&
        !userContext.user.country
      ) {
        pages.push(["Users", () => navigate("/users")]);
        pages.push(["Admins", () => navigate("/admins")]);
      }
      if (["admin"].includes(userContext.user.role))
        pages.push(["Notifications", () => navigate("/notifications")]);
      if (["dj"].includes(userContext.user.role)) {
        const isApproved = userContext.user.status === "approved";
        pages.push(["Library", () => navigate("/library")]);
        pages.push([
          "Payments",
          isApproved ? () => navigate("/payments") : null,
          !isApproved,
        ]);
      }
      if (["karaoke"].includes(userContext.user.role)) {
        pages.push(["Karaoke", () => navigate("/karaoke")]);
      }
      // if (["dj", "venue", "admin"].includes(userContext.user.role)) {
      settings.push(["Profile", handleOpenProfileModal]);
      // }
      settings.push([
        "Log out",
        () => {
          userContext.unsetUser();
          navigate("/");
        },
      ]);
    } else {
      pages.push(["Log In", () => navigate("/login")]);
      pages.push(["Sign Up", () => navigate("/register")]);
    }
    setState((s) => ({
      ...s,
      pages,
      settings,
    }));

    if (!userContext.user?.userId) {
      handleCloseNavMenu();
      handleCloseUserMenu();
      setState((s) => ({
        ...s,
        user: undefined,
      }));
    }
  }, [
    userContext.user,
    navigate,
    userContext,
    isInitialDJSignup,
    location.pathname,
  ]);

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  // const handleLogoClick = () => navigate("/");

  return (
    <>
      {/* <AppBar
        position="static"
        sx={{ backgroundColor: "transparent", position: "fixed" }}
      > */}
      <Container
        sx={{
          backgroundColor: "rgba(22, 11, 36, 0.5)",
          position: "fixed",
          zIndex: 1000,
          width: "100%",
          margin: "auto",
          padding: 0,
          maxWidth: "none!important",
        }}
      >
        <Toolbar disableGutters>
          {/* <Button onClick={handleLogoClick}>
              <img src="logo.png" alt="VIBY Music" style={{ height: 50 }} />
            </Button> */}

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: userContext.user ? "flex" : "none", md: "none" },
            }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="secondary"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: "block",
              }}
              onClick={handleCloseNavMenu}
            >
              {state.pages.map(([name, handleClick, disabled]) => (
                <MenuItem key={name} onClick={handleClick} disabled={disabled}>
                  <Typography textAlign="center">{name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              justifyContent: "center",
              display: { xs: "none", md: "flex" },
            }}
          >
            {state.pages.map(([name, handleClick, disabled]) => (
              <Badge
                key={name}
                badgeContent={djContext?.pendingDjs}
                color="error"
                invisible={name !== "DJs" || djContext?.pendingDjs === 0}
                sx={{ mx: 2, my: 2 }}
              >
                <Button
                  key={name}
                  onClick={handleClick}
                  color="secondary"
                  variant={state.activePage === name ? "contained" : "outlined"}
                  disabled={disabled}
                  sx={
                    disabled
                      ? {
                          color: "rgba(255, 255, 255, 0.5) !important",
                          borderColor: "rgba(255, 255, 255, 0.3) !important",
                          "&.Mui-disabled": {
                            color: "rgba(255, 255, 255, 0.5) !important",
                            borderColor: "rgba(255, 255, 255, 0.3) !important",
                          },
                        }
                      : {}
                  }
                >
                  {name}
                </Button>
              </Badge>
            ))}
          </Box>

          {!userContext.user && (
            <Box
              sx={{
                flexGrow: 1,
                justifyContent: "center",
                display: { xs: "flex", md: "none" }, // Only show on mobile
                gap: 2,
              }}
            >
              {state.pages.map(([name, handleClick]) => (
                <Button
                  key={name}
                  onClick={handleClick}
                  color="secondary"
                  variant={state.activePage === name ? "contained" : "outlined"}
                  size="small"
                >
                  {name}
                </Button>
              ))}
            </Box>
          )}

          <Box sx={{ flexGrow: 0, display: "flex" }}>
            {userContext.user ? (
              <>
                <Tooltip title="Open settings">
                  <IconButton onClick={handleOpenUserMenu}>
                    <Avatar
                      alt={userContext.user.name || userContext.user.username}
                      src={
                        userContext.user.timestamp
                          ? `${config.cdnUrl}/avatars/${userContext.user.userId}?t=${userContext.user.timestamp}`
                          : `${config.cdnUrl}/avatars/${userContext.user.userId}`
                      }
                    />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                  onClick={handleCloseUserMenu}
                >
                  {state.settings.map(([name, handleClick]) => (
                    <MenuItem key={name} onClick={handleClick}>
                      <Typography textAlign="center">{name}</Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </>
            ) : null}
          </Box>
        </Toolbar>
      </Container>
      {/* </AppBar> */}
      {state.open && (
        <ProfileModal
          handleClose={handleClose}
          isInitialDJSignup={isInitialDJSignup}
        />
      )}
    </>
  );
};
export default ResponsiveAppBar;
